module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    staticStyle: {
      "margin-bottom": "1.5em"
    },
    attrs: {
      "id": "block.14.0.0.box.704.756.610.144.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body gtxt_heading",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "para.14.0.0.box.704.756.610.144.q.80"
    }
  }, [_vm._v("Lagniappe")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.14.1.0.box.313.1192.1394.1297.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.14.1.0.box.313.1192.1393.263.q.60"
    }
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Lagniappe ")]), _vm._v("is a Cajun French word that means \"a little something extra\" or \"a little something for nothing.\" In the olden days, whenever a Cajun would shop at a store or at a roadside stand, the proprietor would always throw in a little something with the purchase, just as a gesture of good will. It is somewhat similar to the \"baker's dozen.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.1.box.314.1465.1392.535.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.1.0"
    }
  }), _vm._v("Today, the word has remained with its meaning, but alas, the custom is mostly gone. However, because I give you my "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lagniappe ")]), _vm._v("with each recipe, you get to experience just what the practice was like. These "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lagniappe ")]), _vm._v("sections are filled with hints, suggestions, ideas, cooking techniques, and things that will make using the recipe easier. They might also contain general cooking tips, bits of humor (at least as I see it), and little insights from my years of cooking. Additionally, you will find a complete list of nutritional values per serving with every recipe. There are occasional hints on freezing and refrigerating and bringing the food back to life for a \"second showing.\"")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA13.w.1.2.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.14.1.2.box.314.2010.1393.479.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA13.w.1.2.0"
    }
  }), _vm._v("When I travel around the country to teach my classes, my students tell me over and over again that they like this addition to my cookbooks. In fact, they tell me to put more of myself into the sections. I hope I've done that in this book. The "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lagniappe ")]), _vm._v("sections are somewhat expanded. I have also learned in my traveling around this great land that there are many people out there who really enjoy reading cookbooks just as some people enjoy reading novels. In fact, I heard from one such individual who was on a car trip with her husband. She was reading my last cookbook and just \"laughing up a storm.\" Her husband looked over"), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.0.0"
    }
  }), _c('span', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "para.15.0.0.box.319.315.1394.209.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.0.0"
    }
  }), _vm._v("\nand said, \"I thought you were reading a cookbook!\" Now, I don't want to let you think that I am writing a book of comedy, but I do want you to enjoy my writing, especially in the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lagniappe ")]), _vm._v("sections. I readily admit that I use the this section to step out and just talk to you.")])])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.0.1.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA14"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.15.0.0.box.319.315.1394.428.q.60"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.0.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "102%",
      "text-indent": "1em"
    },
    attrs: {
      "id": "para.15.0.1.box.319.534.1394.209.q.60"
    }
  }, [_vm._v("I honestly hope that you enjoy the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lagniappe ")]), _vm._v("section as much as you enjoy the recipes, and I hope that you take full advantage of them. I really believe that the "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lagniappes ")]), _vm._v("will make the overall experience of "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Cajun ")]), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Healthy ")]), _vm._v("more rewarding, informative, engaging, and delectable!")])]), _vm._v(" "), _c('div', {
    staticClass: "gtxt_inset_box",
    attrs: {
      "id": "block.15.1.0.box.372.1085.1286.480.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_inset_box",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.15.1.0.box.373.1085.1285.261.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.1.0.0"
    }
  }), _vm._v("NOTE: For all recipes, carbohydrate, fat, and protein values are given in grams; cholesterol and sodium values are given in milligrams. \"Trace\" indicates a negligible amount of that item. The values are for one serving or one tablespoon, unless otherwise indicated.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "ORIG-GBS.PA14.w.1.1.0"
    }
  }), _c('p', {
    staticClass: "gtxt_inset_box",
    staticStyle: {
      "font-size": "102%"
    },
    attrs: {
      "id": "para.15.1.1.box.372.1411.1285.154.q.70"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.2.0.0"
    }
  }), _vm._v("A food is considered to be nonfat when it has less than one gram of fat and when that small amount of fat does not impact on the overall caloric content of that food.")])])]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA14.w.3.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }, [_c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('a', {
    staticClass: "page",
    attrs: {
      "id": "ORIG-GBS.PA15"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "gtxt_body",
    attrs: {
      "id": "block.16.0.0.box.810.744.456.246.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "ORIG-GBS.PA15.w.0.0.0"
    }
  }), _c('p', {
    staticClass: "gtxt_body",
    staticStyle: {
      "font-size": "140%",
      "text-align": "center",
      "font-weight": "bold"
    },
    attrs: {
      "id": "para.16.0.0.box.810.744.456.246.q.80"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA15"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA15.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA16.w.0.0.0"
    }
  }), _vm._v("CAJUN HEALTHY")]), _c('a', {
    attrs: {
      "id": "GBS.PA17"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.0.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.1.0.0"
    }
  })]), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.2.0.0"
    }
  }), _c('a', {
    attrs: {
      "id": "GBS.PA17.w.3.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.4.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.5.0.0"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.6.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.6.0.0.1"
    }
  })]), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.7.0.0"
    }
  })]), _c('div', {
    staticClass: "flow"
  }), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.8.0.0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flow"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('a', {
    attrs: {
      "id": "GBS.PA17.w.8.0.0.1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19d27325","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/content-0009.vue
// module id = 60
// module chunks = 0